import { c as _c } from "react/compiler-runtime";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { getApprovalDropStatus } from "@/helpers/waves/approve-wave.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveLeaderboardGalleryItemVotesProps {
  readonly drop: ExtendedDrop;
  readonly variant?: "default" | "subtle" | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export default function WaveLeaderboardGalleryItemVotes(t0) {
  const $ = _c(30);
  const {
    drop,
    variant: t1,
    winningThreshold,
    isVotingClosed: t2
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const displayWinningThreshold = typeof winningThreshold === "number" && Number.isFinite(winningThreshold) && winningThreshold > 0 ? winningThreshold : null;
  let approvalStatus;
  let current;
  let getColorClass;
  let t3;
  if ($[0] !== displayWinningThreshold || $[1] !== drop || $[2] !== isVotingClosed || $[3] !== variant) {
    approvalStatus = displayWinningThreshold !== null ? getApprovalDropStatus({
      drop,
      isClosed: isVotingClosed,
      winningThreshold: displayWinningThreshold
    }) : null;
    current = approvalStatus?.current ?? drop.rating;
    const isPositive = current >= 0;
    let t4;
    if ($[8] !== isPositive || $[9] !== variant) {
      t4 = () => {
        if (variant === "subtle") {
          return "tw-text-iron-200";
        }
        return isPositive ? "tw-text-emerald-500" : "tw-text-rose-500";
      };
      $[8] = isPositive;
      $[9] = variant;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    getColorClass = t4;
    bb0: {
      if (approvalStatus === null) {
        t3 = null;
        break bb0;
      }
      if (approvalStatus.kind === "approved") {
        t3 = "Approved";
        break bb0;
      }
      if (approvalStatus.kind === "reached_threshold") {
        t3 = "Reached threshold";
        break bb0;
      }
      if (approvalStatus.kind === "closed") {
        t3 = "Closed";
        break bb0;
      }
      t3 = `Needs ${formatNumberWithCommas(approvalStatus.remaining ?? 0)}`;
    }
    $[0] = displayWinningThreshold;
    $[1] = drop;
    $[2] = isVotingClosed;
    $[3] = variant;
    $[4] = approvalStatus;
    $[5] = current;
    $[6] = getColorClass;
    $[7] = t3;
  } else {
    approvalStatus = $[4];
    current = $[5];
    getColorClass = $[6];
    t3 = $[7];
  }
  const approvalStatusLabel = t3;
  let t4;
  bb1: {
    if (approvalStatus?.kind === "approved" || approvalStatus?.kind === "reached_threshold") {
      t4 = "tw-text-emerald-400";
      break bb1;
    }
    if (approvalStatus?.kind === "closed") {
      t4 = "tw-text-amber-300";
      break bb1;
    }
    t4 = variant === "subtle" ? "tw-text-iron-400" : "tw-text-iron-300";
  }
  const approvalStatusClass = t4;
  const t5 = `tw-font-mono tw-text-sm tw-font-bold ${getColorClass()}`;
  let t6;
  if ($[11] !== current) {
    t6 = formatNumberWithCommas(current);
    $[11] = current;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== displayWinningThreshold) {
    t8 = displayWinningThreshold !== null ? <><span className="tw-font-mono tw-text-sm tw-font-bold tw-text-iron-500">/</span><span className="tw-font-mono tw-text-sm tw-font-bold tw-text-iron-200">{formatNumberWithCommas(displayWinningThreshold)}</span></> : null;
    $[16] = displayWinningThreshold;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = variant === "subtle";
  let t10;
  if ($[18] !== current || $[19] !== drop.rating_prediction || $[20] !== t9) {
    t10 = <DropVoteProgressing current={current} projected={drop.rating_prediction} subtle={t9} />;
    $[18] = current;
    $[19] = drop.rating_prediction;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== approvalStatusClass || $[23] !== approvalStatusLabel) {
    t11 = approvalStatusLabel !== null ? <span className={`tw-whitespace-nowrap tw-text-xs tw-font-medium ${approvalStatusClass}`}>{approvalStatusLabel}</span> : null;
    $[22] = approvalStatusClass;
    $[23] = approvalStatusLabel;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t7 || $[28] !== t8) {
    t12 = <div className="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2">{t7}{t8}{t10}{t11}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t7;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}